import React, { useContext } from 'react'
import useRouter from 'utils/useRouter'
import { ListItemIcon, ListItemText } from '@material-ui/core'
import { ObjetoAvatar } from 'components/ObjetoAvatar'
import { DetalhesCasoContext } from '../../DetalhesCasoContext'
import { StyledMenu, StyledMenuItem } from './MenuAdd.styles'

export const MenuAdd = (props) => {
  const router = useRouter()
  const context = useContext(DetalhesCasoContext)

  if (!context || !context.caso) return null

  const items = [
    {
      label: 'Vestígio',
      tipo: 'VESTIGIO',
      route: `/casos/caso/cadastrarvestigio/${context.caso.id}`,
    },
    {
      label: 'Cadáver',
      tipo: 'CADAVER',
      route: `/casos/caso/cadastrarCadaver/${context.caso.id}`,
    },
    {
      label: 'Periciando',
      tipo: 'PERICIANDO',
      route: `/casos/caso/cadastrarpericiando/${context.caso.id}`,
    },
    {
      label: 'Veículo',
      tipo: 'VEICULO',
      route: `/casos/caso/cadastrarveiculo/${context.caso.id}`,
    },
    {
      label: 'Local',
      tipo: 'LOCAL',
      route: `/casos/caso/cadastrarlocal/${context.caso.id}`,
    },
    {
      label: 'Solicitação de Exame',
      tipo: 'SOLICITACAO',
      route: `/casos/caso/cadastrarsolicitacao/${context.caso.id}`,
      state: { setorResponsavel: context.caso.setRes },
    },
  ]

  return (
    <StyledMenu {...props}>
      {items.map((item, index) => (
        <StyledMenuItem key={index} onClick={() => router.history.push(item.route, item.state)}>
          <ListItemIcon>
            <ObjetoAvatar tipo={item.tipo} />
          </ListItemIcon>
          <ListItemText primary={item.label} />
        </StyledMenuItem>
      ))}
    </StyledMenu>
  )
}
